import { useEffect, useState } from 'react';
import { getActivation } from '../api/onboarding';

// ONB-001 (Macrofase A) — ¿la venta que el punto de venta acaba de completar es la PRIMERA del negocio?
//
// Solo se pregunta con una venta que el servidor ya devolvió completada (CONFIRMED): el llamador lo
// garantiza (la rama «Venta completada» del POS). Y la respuesta también es del servidor: la venta es la
// primera si es la ÚNICA venta completada del negocio. Una venta pendiente, un pago UNKNOWN, una venta
// cancelada o un «cobro confirmado, venta sin completar» (FI-53) nunca llegan aquí ni cuentan allá.
//
// Costo para los negocios de siempre: ninguno hasta que se completa una venta, y entonces una sola
// lectura por sesión. En cuanto el servidor dice que este negocio no es guiado, o que ya tiene más de una
// venta, no se vuelve a preguntar (la respuesta no puede cambiar a «sí»).
const settledBusinesses = new Set<string>();

export function useFirstSale(saleId: string | undefined, businessId: string | undefined, enabled: boolean): boolean {
  const [firstSaleId, setFirstSaleId] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || !saleId || !businessId || settledBusinesses.has(businessId)) return undefined;
    let alive = true;
    getActivation()
      .then((activation) => {
        const settled = !activation.guided || (activation.hasCompletedSale && activation.onlyCompletedSaleId === null);
        if (settled) settledBusinesses.add(businessId);
        if (alive && activation.guided && activation.onlyCompletedSaleId === saleId) setFirstSaleId(saleId);
      })
      // Sin respuesta no se festeja —«Venta completada» ya dice lo que importa— y no se vuelve a preguntar en
      // esta sesión: el punto de venta no debe sumar una lectura fallida a cada venta mientras algo falla.
      .catch(() => { settledBusinesses.add(businessId); });
    return () => { alive = false; };
  }, [saleId, businessId, enabled]);

  return saleId !== undefined && firstSaleId === saleId;
}

/** Solo para pruebas: olvida lo aprendido entre casos. */
export function resetFirstSaleCache(): void {
  settledBusinesses.clear();
}
